<template>
    <div>
        <el-form ref="formRef" :rules='formRules' :model="form" label-width="90px">
                <el-row :gutter="24">
                      <el-col :span="8">
                          <el-form-item label="项目名称" prop="projectId" >
                              <el-select :disabled="!isEdit"  v-model="form.projectId" placeholder="请选择" style="width:100%" @change="projectIdChange">
                                  <el-option
                                      v-for="item in projectList"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="设备名称" prop="deviceId" >            
                                <div style="display:flex">
                                        <el-input v-model="form.deviceName" disabled></el-input>
                                        <el-button type="primary" size="small" @click="choiceDevice" v-if="isEdit">选择</el-button> 
                                </div>
                          </el-form-item>
                      </el-col>

                      <el-col :span="8">
                          <el-form-item label="设备类型" prop="deviceType">
                             <el-input v-model="form.deviceType" disabled></el-input>
                          </el-form-item>
                      </el-col>
                    
                      <el-col :span="8">
                          <el-form-item label="设备编号" prop="code" >
                              <el-input disabled v-model="form.code"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="所属部门" prop="deptName" >
                              <el-input disabled v-model="form.deptName"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="存放位置" prop="areaName" >
                              <el-input disabled v-model="form.areaName"></el-input>
                          </el-form-item>
                      </el-col>
                      
                      <el-col :span="8" style="height:54px" >
                          <el-form-item  label="巡检时间" prop="realInspectTime" style="width:100%" >
                            
                             <el-date-picker
                             :disabled="!isEdit"  
                             style="width:100%" 
                            v-model="form.realInspectTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            align="right"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            >
                            </el-date-picker>
                          </el-form-item>
                      </el-col>
                      <el-col :span="8">
                          <el-form-item label="巡检人员" prop="realInspectManId" >
                                
                               <choice-people :limit="1" :allUserList='realInspectManList' :remainUserListInside.sync="realInspectManList" :projectId="form.projectId" :disabled="!isEdit" :message="请选择巡检人"  ></choice-people>
                              <!-- <avue-input-tree :disabled="!isEdit" type="tree"  v-model="form.realInspectManId" placeholder="请选择巡检人"  :dic="handleIdList"></avue-input-tree> -->
                          </el-form-item>
                      </el-col>
                       <el-col :span="8" v-if="form.orderCode">
                          <el-form-item label="工单编号" prop="orderCode" >
                              <el-input disabled v-model="form.orderCode"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="巡检标准" prop="InspectionStatus"  >
                               <el-table
                                :data="standardList"
                                border
                                style="width: 100%">
                                <el-table-column
                                  type="index"
                                  label="序号"
                                  width="50">
                                </el-table-column>
                                <el-table-column
                                  prop="standardDetailContent"
                                  label="标准内容"
                                  >
                                </el-table-column>
                                <el-table-column
                                  
                                  label="操作"
                                  width="300">
                                  <template slot-scope="scope">
                                    <div>
                                      
                                      <el-button size="mini" type="primary" 
                                      :disabled="item.dictKey==scope.row.selectedOperation"
                                       v-for="(item, index) in currentDataOption" 
                                       :key="index"
                                       @click="standardEvaluate(scope.row,item.dictKey,item.dictValue)"
                                       
                                        >{{item.dictValue}}</el-button>
                                    </div>
                                  </template>
                                </el-table-column>
                              </el-table>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="巡检结果" prop="errorFlag" >
                              <el-select  :disabled="!isEdit" v-model="form.errorFlag" placeholder="请选择"  >
                                  <el-option
                                      v-for="item in inspectionResultList"
                                      :key="item.errorFlag"
                                      :label="item.name"
                                      :value="item.errorFlag">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="备注" prop="description" >
                              <el-input :disabled="!isEdit" type="textarea" v-model="form.description" maxlength="200"></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="24">
                          <el-form-item label="上传附件" prop="code" >
                              <VUpload :disabled="!isEdit" :fileList="form.attachList"></VUpload>
                          </el-form-item>
                      </el-col>
                      
                </el-row>
          </el-form>
            
            <div class="btnArea" style="text-align:right" v-if="isEdit">
                <el-button type="primary" @click="submitRecord" style="margin-right: 20px"
                 v-if="isEdit" >确定</el-button
                >
                <el-button @click="closeRecord" v-if="cancelBtn">取消</el-button>
            </div>
            <!-- 选择设备对话框 -->
            <el-dialog
            title="选择设备"
            v-if="choiceDeviceDialogFlag"
            :visible.sync="choiceDeviceDialogFlag"
            append-to-body="true"
            width="80%"
            >
            <choiceDevice @cancleOperate="choiceDeviceCancleOperate" :projectId="this.form.projectId" @choiceData="getDevice"></choiceDevice>
            </el-dialog>
           
    </div>
</template>

<script>
import {
  getBisDictData,
  getStandardByDeviceId,
  saveInspectRecord,
  updateInspectRecord,
} from '@/api/crmedical/device/deviceInspectionStandard';

import choiceConsumable from '@/components/consumable/choiceConsumable';
import choiceDevice from '@/components/device/deviceChoice/index';
import VUpload from '@/views/components/v-upload';
import choiceContract from '@/components/choiceContract/choiceContract';
import ATime from '@/components/aTime/index';
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import { getProjectList, getGroupListByModuleType } from '@/api/crmedical/group/group';
import { setTimeout } from 'timers';
import { async } from 'q';
export default {
  components: { VUpload, choiceContract, choiceDevice, choiceConsumable, ATime ,choicePeople},
  props: {
    cancelBtn:{
        type:Boolean,
        default:true,

    },
    form: {
      default: {
        projectId: '',
        attachList: [],
      },
    },
    isWatch: false,
    isEdit: false,
    projectList: [],
  },
  data() {
    return {
      realInspectManList:[],
      inspectionResultList: [
        {
          errorFlag: 1,
          name: '异常',
        },
        {
          errorFlag: 0,
          name: '正常',
        },
      ],
      standardList: [],
      currentDataOption: [],
      handleIdList: [], //处理人
      OperateList: [],
      isUpdate: false,
      //判断是否为编辑
      operatConsumableIndex: undefined,
      choiceConsumableFlag: false, //选择耗材对话框
      choiceContractDialogFlag: false, //选择设备对话框
      choiceDeviceDialogFlag: false, //选择设备对话框
      consumable: {
        consumableId: '',
        consumableName: '',
        specification: '',
        vender: '',
        consumeNum: '',
        consumePrice: '',
      },
      consumablesList: [
        {
          consumableId: '',
          consumableName: '',
          specification: '',
          vender: '',
          consumeNum: '',
          consumePrice: '',
        },
      ],
      dialogVisible: false,
      dialogConstract: {},
      formRules: {
        deviceId: [{ required: true, message: '请选择设备', trigger: 'change' }],
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        realInspectTime: [{ required: true, message: '请选择巡检时间', trigger: 'blur' }],
        realInspectManId: [{ required: true, message: '请选择巡检人', trigger: 'change' }],
        errorFlag: [{ required: true, message: '请选择巡检结果', trigger: 'blur' }],
      },
    };
  },
  created() {
    console.log(this.projectId)
    this.form.projectId = this.form.projectId ? this.form.projectId : this.projectId;
    console.log("+++++++++",this.form)
    if (!this.isWatch) {//判断编辑还是查看
      this.$set(this.form, 'InspectionStatus', true);
      this.$set(this.form, 'realInspectManId', '');
      this.$set(this.form, 'realInspectTime', '');
      this.$set(this.form, 'errorFlag', '');
      this.$set(this.form, 'deviceId', '');
       this.$set(this.form, 'description', '');
       this.$set(this.form,'attachList',[])
    } else {
      this.$set(this.form, 'InspectionStatus', true);
      let obj = {
        id:this.form.realInspectManId,
        realNameAndPhone:this.form.realInspectManName,
        realName:this.form.realInspectManName,
      }
      this.realInspectManList.push(obj)
      this.standardList = this.form.deviceInspectTaskListStandards;
    }
    console.log("realInspectManList",this.realInspectManList)
    this.initData();
  },
  watch:{

     realInspectManList: {
      handler() {
        if(this.realInspectManList.length>0){
          this.$set(this.form,"realInspectManId",this.realInspectManList[0].id)
          this.form.realInspectManName = (this.realInspectManList[0].realName).replace(/\([0-9]*\)(?!.*\1)/g, ``);//删除手机号
        }
          
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    
    choiceDeviceCancleOperate() {
      this.choiceDeviceDialogFlag = false;
    },
    projectIdChange(val) {
      getBisDictData({
        code: 'project_device_inspect_operation',
        projectId: val,
      }).then((res)=>{
        this.OperateList = res.data;
      })
      this.handleIdList = [];
      this.form.deviceName = '';
      this.form.deviceId = '';
      this.form.deviceType=''
      this.form.code = '';
      this.form.deptName = '';
      this.form.areaName = '';
      this.form.realInspectTime = '';
      this.form.realInspectManId = '';
      this.form.realInspectManName = '';
      this.form.deviceInspectTaskListStandards = [];
      this.form.errorFlag = '';
      this.currentDataOption = [];
      this.standardList = [];
      this.form.attachList=[]
      this.form.description=''
      this.realInspectManList = []
      this.$forceUpdate()
    },
    standardEvaluate(row, optionValue, optionName) {
      if (this.isEdit) {
        this.$set(row, 'selectedOperation', optionValue);
        this.$set(row, 'selectedOperationValue', optionName);
        this.$message.success('操作成功');
        console.log('操作后', this.standardList);
      } else {
        return;
      }
    },
    maintenanceTime(date) {
      //维修完成时间
      this.form.serviceHour = Number(date.hour) * 60 + Number(date.minutes);
    },
    initData() {
      getBisDictData({
        code: 'project_device_inspect_operation',
        projectId: this.form.projectId,
      }).then((res) => {
        this.OperateList = res.data;
        console.log('操作选择', this.OperateList);
        console.log('操作optionalOperations', this.form.optionalOperations);
        if (this.form.optionalOperations) {
          let arry = this.form.optionalOperations.split(',');
          this.OperateList.forEach((item) => {
            arry.forEach((ele) => {
              if (item.dictKey == ele) {
                let obj = {
                  dictKey: item.dictKey,
                  dictValue: item.dictValue,
                };
                this.currentDataOption.push(obj);
              }
            });
          });
        }
      });
     
      console.log('所有form数据', this.form);
    },
    submitRecord() {
      console.log(this.form);
      console.log(this.realInspectManList)
      this.$refs['formRef'].validate(async(valid) => {
        if (valid) {
          if(this.standardList.length>0){
            for (let i = 0; i < this.standardList.length; i++) {
            if (this.standardList[i].selectedOperation) {
              continue;
            } else {
              // this.form.InspectionStatus = false;
              this.$message.error('巡检标准必须全部评价！');
              return;
            }
          } //判断是否所有的标准都评价了
          }
          
          if (this.form.InspectionStatus) {
            let arrVaule = [];
            let arrName = [];
            console.log('this.currentDataOption', this.currentDataOption);
            this.currentDataOption.forEach((item) => {
              arrVaule.push(item.dictKey);
              arrName.push(item.dictValue);
            });
           
            let obj = {
              deviceInspectTaskListStandards: this.standardList,
              optionalOperations: arrVaule.join(','),
              optionalOperationValues: arrName.join(','),
            };
            if(this.standardList.length>0){//后端的要求
              obj.standardId = this.standardList[0].standardId
              obj.standardName = this.standardList[0].standardName
            }
            console.log(this.form);
            if (this.isEdit && this.isWatch) {
            await updateInspectRecord(Object.assign({}, this.form, obj)).then(() => {
                this.$message.success('编辑巡检记录成功'); 
              });
            
               
                this.$emit('submitOver');
             
            } else {
            await  saveInspectRecord(Object.assign({},  this.form, obj)).then(() => {
                this.$message.success('新增巡检记录成功');
                
                 
              });
              
                this.$emit('submitOver');
              
            }
           
          } else {
            this.$message.error('巡检标准必须全部评价！');
            return;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getDevice(val) {
      console.log(val);
      console.log('查询标准');
      //根据设备id查找标准
      getStandardByDeviceId({ id: val.id }).then(({ data }) => {
        this.standardList = data;
        this.standardList.forEach((item) => {
          item.standardDetailContent = item.content;
        });
        let arry = data[0].optionalOperations.split(',');
        console.log('arry', arry);
        console.log('this.standardList', this.standardList);
        this.OperateList.forEach((item) => {
          arry.forEach((ele) => {
            if (item.dictKey == ele) {
              let obj = {
                dictKey: item.dictKey,
                dictValue: item.dictValue,
              };
              this.currentDataOption.push(obj);
            }
          });
        });
       
      });
      
      this.$set(this.form, 'deviceId', val.id);
      this.$set(this.form, 'deviceName', val.name);

      this.form.areaName = val.areaName;
      this.form.deviceType = val.typeName;
      this.form.code = val.code;
      this.form.deptName = val.deptName;
      this.choiceDeviceDialogFlag = false;
    },

    choiceDevice() {
      this.choiceDeviceDialogFlag = true;
    },

    closeRecord() {
      this.$emit('cancelOperate');
    },
    dialogClose() {
      this.dialogVisible = false;
    },
    getGroupListByModuleType(projectId) {
      getGroupListByModuleType({ projectId: projectId }).then((res) => {
        res.data.forEach((item) => {
          item.label = item.realNameAndPhone;
          item.value = item.userId;
        });
        this.handleIdList = res.data;
      });
    },
    
  },
};
</script>

<style scoped>
.btn {
  width: 100%;
  border: none;
  height: 30px;
  background: #409eff;
  font-size: 25px;
  color: #fff;
  line-height: 30px;
  margin-top: 10px;
}
.btn::after {
  display: none;
}
.btnArea {
  margin-top: 10px;
  text-align: center;
}
</style>
